/**
 * @file: StoreHouse.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食品库存信息
 */
import request from '@/utils/request'

/**
 * 库存分析-库存信息统计
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function storehouseBigdataInfoGet(data) {
  return request({
    type: 'biz',
    url: 'storehouse/bigdata/info/get',
    method: 'post',
    data
  })
}

/**
 * 供应商对比分析-供应商分析报表部分导出（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function storehouseBigdataListExport(data) {
  return request({
    type: 'biz',
    url: 'storehouse/bigdata/list/export',
    method: 'post',
    data
  })
}

/**
 * 库存分析-库存分析报表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function storehouseBigdataListGet(data) {
  return request({
    type: 'biz',
    url: 'storehouse/bigdata/list/get',
    method: 'post',
    data
  })
}

/**
 * 供应商对比分析-供应商分析报表部分导出（wrp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function storehouseBigdataListOptionExport(data) {
  return request({
    type: 'biz',
    url: 'storehouse/bigdata/list/option/export',
    method: 'post',
    data
  })
}

/**
 * 食品信息详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function storehouseInfoGet(data) {
  return request({
    type: 'biz',
    url: 'storehouse/info/get',
    method: 'post',
    data
  })
}

/**
 * 食品信息列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function storehouseListGet(data) {
  return request({
    type: 'biz',
    url: 'storehouse/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/StoreHouse.js